import React, { Component } from 'react';
import { Text, TouchableWithoutFeedback, View, Modal } from 'react-native';
import { observer, inject } from 'mobx-react/native';
import { Picker } from 'qunar-react-native';
import InputAreaInterface from '../../../stores/inputTelephoneNum/inputArea';
import styles from './style';

// const qpVersion = getQpVersion();

interface Props {
    inputArea?: InputAreaInterface;
}



@inject('inputArea')
@observer
class TimePicker extends Component<Props> {

    render() {
        const {
            inputArea: {
                isShowTimePicker
            }
        } = this.props;
        const {inputArea} = this.props;

        const currentYear = new Date().getFullYear();

        return (<Modal visible={isShowTimePicker} transparent={true}>
            <TouchableWithoutFeedback onPress={this.dismiss}>
                <View style={{ flex: 1, backgroundColor: "#00000099" }} />
            </TouchableWithoutFeedback>
            <View style={styles.pickerHeader}>
                <Text style={styles.cancel} onPress={this.dismiss}>取消</Text>
                <Text style={styles.title}>选择年份</Text>
                <Text style={styles.confirm} onPress={() => {
                    inputArea.currentSelectYear = inputArea.tempSelectYear;
                    this.dismiss();
                }}>完成</Text>
            </View>
            <Picker
                style={styles.pickerContainer}
                selectedValue={inputArea.tempSelectYear}
                onValueChange={(value: any) => {
                    inputArea.tempSelectYear = value;
                }}
            >
                <Picker.Item label={String(currentYear - 3)} value={currentYear - 3} />
                <Picker.Item label={String(currentYear - 2)} value={currentYear - 2} />
                <Picker.Item label={String(currentYear - 1)} value={currentYear - 1} />
                <Picker.Item label={String(currentYear)} value={currentYear} />
            </Picker>

        </Modal>);
    }


    dismiss = () => {
        this.props.inputArea.isShowTimePicker = false;
    }

}

export default TimePicker;
